import React from 'react';
import Flex from '../Flex/Flex';
import P from '../Texts/P/P';
import Illustration from '../Image/Illustration/Illustration';
import * as S from './NoItems.styles';

const NoItems = () => {
  return (
    <Flex column>
      <S.IllustrationWrapper>
        <Illustration name='lineal_establecimientos_empty' alt='No hay datos' />
      </S.IllustrationWrapper>
      <P type='2' variant='neutral' weight='regular' align='center'>
        No se encontraron resultados que coincidan con tu búsqueda
      </P>
    </Flex>
  );
};

export default NoItems;
